<template>
  <div class="home_page">
    <div class="topNav">
      <div
        class="btn_item pointer"
        v-for="item in btnList"
        :key="item.type"
        @click="handleBtnClick(item.type)"
      >
        {{ item.label }}
      </div>
      <el-dropdown @command="handleCommand">
        <div class="btn_item pointer">共享备件</div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item :command="6"
            >备件发布</el-dropdown-item
          >
          <el-dropdown-item :command="7"
            >共享备件</el-dropdown-item
          >
        </el-dropdown-menu>
      </el-dropdown>
    </div>
    <template v-if="$route.name === 'storeSpare'">
      <Breadcrumb :pageTitle="pageTitle" />
      <div class="storeSpare_console">
        <div class="title flex-sp">
          {{ $t("dashboard.title") }}
          <!-- <div class="btn" @click="openDataV">
            <img src="../../../assets/img/lclb/indexBtn.png" alt="" srcset="" />
            平台数据总览
          </div> -->
        </div>
        <div class="list_box flex-sp">
          <el-card class="list_item bg_01">
            <div>
              <div class="list_title">{{ $t("dashboard.totalJoint") }}</div>
              <div class="list_num_box">
                <span class="list_num"
                  ><countTo
                    :startVal="0"
                    :endVal="platformInfo.companyNum || 0"
                    :duration="3000"
                  ></countTo
                ></span>
                <span class="list_num_unit">家</span>
              </div>
            </div>
          </el-card>
          <el-card class="list_item bg_02">
            <div>
              <div class="list_title">{{ $t("dashboard.spareTotal") }}</div>
              <div class="list_num_box">
                <span class="list_num"
                  ><countTo
                    :startVal="0"
                    :endVal="platformInfo.sparePartsNum || 0"
                    :duration="3000"
                  ></countTo
                ></span>
                <span class="list_num_unit">件</span>
              </div>
            </div>
          </el-card>
          <el-card class="list_item bg_03">
            <div>
              <div class="list_title">{{ $t("dashboard.spareRequired") }}</div>
              <div class="list_num_box">
                <span class="list_num"
                  ><countTo
                    :startVal="0"
                    :endVal="platformInfo.orderGoodsNum || 0"
                    :duration="3000"
                  ></countTo
                ></span>
                <span class="list_num_unit">件</span>
              </div>
            </div>
          </el-card>
          <el-card class="list_item">
            <div>
              <div class="list_title color">
                {{ $t("dashboard.needOrders") }}
              </div>
              <div class="list_num_box">
                <span class="list_num color_01"
                  ><countTo
                    :startVal="0"
                    :endVal="platformInfo.sparePartsDemandNum || 0"
                    :duration="3000"
                  ></countTo
                ></span>
                <span class="list_num_unit color">单</span>
              </div>
            </div>
          </el-card>
          <el-card class="list_item">
            <div>
              <div class="list_title color">
                {{ $t("dashboard.spareTypesTotal") }}
              </div>
              <div class="list_num_box">
                <span class="list_num color_02"
                  ><countTo
                    :startVal="0"
                    :endVal="platformInfo.sparePartsDemandSkuNum || 0"
                    :duration="3000"
                  ></countTo
                ></span>
                <span class="list_num_unit color">种</span>
              </div>
            </div>
          </el-card>
          <el-card class="list_item">
            <div>
              <div class="list_title color">
                {{ $t("dashboard.spareTypesRequired") }}
              </div>
              <div class="list_num_box">
                <span class="list_num color_03"
                  ><countTo
                    :startVal="0"
                    :endVal="platformInfo.orderSkuNum || 0"
                    :duration="3000"
                  ></countTo
                ></span>
                <span class="list_num_unit color">种</span>
              </div>
            </div>
          </el-card>
        </div>
        <div class="title">{{ $t("dashboard.engagedJoint") }}</div>
        <div class="company_list flex-sp">
          <div ref="sparePart" class="company_list_item"></div>
          <div ref="requisition" class="company_list_item"></div>
          <div ref="request" class="company_list_item"></div>
        </div>
        <div class="lclb_map">
          <div style="margin: 20px 0">{{ $t("dashboard.orderSource") }}</div>

          <BaiduMap
            class="baidumap"
            :ak="bMapInfo.ak"
            :zoom="bMapInfo.zoom"
            :center="bMapInfo.center"
            :scroll-wheel-zoom="true"
          >
            <BmPointCollection
              v-if="points.length"
              :points="points"
              shape="BMAP_POINT_SHAPE_CIRCLE"
              color="#6357E9"
              :data-points="points"
              size="BMAP_POINT_SIZE_BIG"
              @mouseover="clickHandler"
              @mouseout="mouseout"
            ></BmPointCollection>
            <BmInfoWindow
              :position="{ lng: bmInfo.lng, lat: bmInfo.lat }"
              :title="bmInfo.city"
              :show="bmInfo.show"
            >
              <p>{{ bmInfo.countNum }} 单</p>
            </BmInfoWindow>
          </BaiduMap>
        </div>
        <div class="title">{{ $t("dashboard.onlineStore") }}</div>
        <div class="shop_box flex-sp">
          <div class="shop_left">
            <div class="shop_left_title">{{ $t("dashboard.allCustomer") }}</div>
            <div class="shop_left_num">{{ shoppingInfo.companyNum }}</div>
            <div class="shop_left_bottom flex-sp">
              <el-card class="shop_left_bottom_item">
                <div class="shop_left_bottom_title">
                  {{ $t("dashboard.revenue") }}
                </div>
                <div class="shop_left_bottom_num">
                  <countTo
                    :startVal="0"
                    :endVal="Number(shoppingInfo.orderPaymentTotalAmount) || 0"
                    :duration="3000"
                  ></countTo>
                </div>
              </el-card>
              <el-card class="shop_left_bottom_item">
                <div class="shop_left_bottom_title">
                  {{ $t("dashboard.orders") }}
                </div>
                <div class="shop_left_bottom_num">
                  <countTo
                    :startVal="0"
                    :endVal="shoppingInfo.orderPaymentTotalNum || 0"
                    :duration="3000"
                  ></countTo>
                </div>
              </el-card>
              <el-card class="shop_left_bottom_item">
                <div class="shop_left_bottom_title">
                  {{ $t("dashboard.supplier") }}
                </div>
                <div class="shop_left_bottom_num">
                  <countTo
                    :startVal="0"
                    :endVal="2186"
                    :duration="3000"
                  ></countTo>
                </div>
              </el-card>
              <el-card class="shop_left_bottom_item">
                <div class="shop_left_bottom_title">
                  {{ $t("dashboard.sku") }}
                </div>
                <div class="shop_left_bottom_num">
                  <countTo
                    :startVal="0"
                    :endVal="shoppingInfo.countSkuNum || 0"
                    :duration="3000"
                  ></countTo>
                </div>
              </el-card>
            </div>
          </div>
          <div class="shop_box_right" ref="newCompany"></div>
        </div>
      </div>
    </template>
    <router-view v-else />
  </div>
</template>
<script>
import Breadcrumb from "@/components/breadcrumb/index";
import BaiduMap from "vue-baidu-map/components/map/Map.vue";
import CountTo from "vue-count-to";
import Vue from "vue";
import {
  BmOverviewMap,
  BmPointCollection,
  BmInfoWindow,
  BmlMarkerClusterer,
  BmMarker,
} from "vue-baidu-map";
const echarts = require("echarts");
export default {
  components: {
    Breadcrumb,
    BaiduMap,
    BmPointCollection,
    BmOverviewMap,
    BmInfoWindow,
    BmlMarkerClusterer,
    BmMarker,
    CountTo,
  },
  data() {
    return {
      bMapInfo: {
        ak: "N1WjOLWHjT7iHajZ9HbdEU0kh884SPmd",
        zoom: 5,
        center: "杭州",
      },
      points: [
        // 地图标注
      ],
      bmInfo: {
        show: false,
        name: "杭州",
        lng: "120.21666",
        lat: "30.254579",
        value: 13,
      },
      pageTitle: [
        {
          label: this.$t("header.homepage"),
          url: "/",
        },
        {
          label: this.$t("header.storeSpare"),
          url: "/storeSpare",
        },
        {
          label: this.$t("header.dashboard"),
        },
      ],
      // 数据大盘
      sparePart: null,
      sparePartOption: {
        title: [
          {
            text: this.$t("dashboard.requisition"),
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        nameTextStyle: {
          fontSize: 12,
        },
        xAxis: [
          {
            type: "category",
            data: [
              this.$t("dashboard.spareParts"),
              this.$t("dashboard.need"),
              this.$t("dashboard.order"),
            ],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: this.$t("common.quantity"),
            type: "bar",
            barWidth: "20%",
            data: [],
          },
        ],
      },
      // 备件领用单
      requisition: null,
      requisitionOption: {
        title: [
          {
            text: this.$t("dashboard.history"),
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: {
          type: "category",
          data: [
            "2021-05",
            "2021-06",
            "2021-07",
            "2021-08",
            "2021-09",
            "2021-10",
          ],
          axisTick: {
            alignWithLabel: true,
          },
        },
        yAxis: {
          type: "value",
        },
        series: [
          {
            name: this.$t("common.quantity"),
            data: [2, 12, 27, 4, 14, 8],
            type: "line",
          },
        ],
      },
      // 备件请求统计
      request: null,
      requestOption: {
        title: [
          {
            text: this.$t("dashboard.spareCity"),
          },
        ],
        grid: {
          left: "-10%",
          right: "4%",
          bottom: "3%",
          containLabel: false,
        },
        tooltip: {
          trigger: "item",
        },
        legend: {
          orient: "vertical",
          top: "center",
          right: "0",
          icon: "circle",
        },
        series: [
          {
            name: this.$t("dashboard.requestSource"),
            type: "pie",
            radius: ["20%", "56%"],
            avoidLabelOverlap: false,
            label: {
              show: true,
              position: "inner",
              formatter: "{d}",
            },
            emphasis: {
              label: {
                show: true,
                fontSize: "10",
                fontWeight: "bold",
              },
            },
            labelLine: {
              show: false,
            },
            data: [
              { value: 43570, name: "杭州市" },
              { value: 5657, name: "宁波市" },
              { value: 12206, name: "贵州省" },
              { value: 2707, name: "黑龙江省" },
              { value: 1600, name: "广东省" },
            ],
          },
        ],
      },
      // 新企业注册数
      newCompany: null,
      newCompanyOption: {
        title: [
          {
            text: this.$t("dashboard.yearly"),
          },
        ],
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        grid: {
          left: "3%",
          right: "4%",
          bottom: "3%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            data: [],
            axisTick: {
              alignWithLabel: true,
            },
          },
        ],
        yAxis: [
          {
            type: "value",
          },
        ],
        series: [
          {
            name: this.$t("common.quantity"),
            type: "bar",
            barWidth: "40%",
            data: [],
          },
        ],
      },
      platformInfo: {
        // 平台信息
      },
      shoppingInfo: {
        // 商城信息
      },
      btnList: [
        { label: this.$t("header.dashboard"), type: 1 },
        { label: this.$t("header.spareRequisition"), type: 2 },
        { label: this.$t("header.stockInquiry"), type: 3 },
        { label: this.$t("header.spareOrder"), type: 4 },
        { label: "对账结算", type: 5 },
      ],
    };
  },
  mounted() {
    this.sparePartInfo(); // 数据大盘
    this.requisitionInfo(); // 领用单记录
    this.requestInfo(); // 备件数
    this.newCompanyInfo(); // 新企业
    this.getMapInfo(); // 获取地图信息
    this.getShoppingInfo(); // 获取商城信息
  },
  methods: {
    clickHandler(e) {
      let index = this.points.findIndex((item) => {
        // eslint-disable-next-line eqeqeq
        return e.point.lng == item.lng && e.point.lat == item.lat;
      });
      this.bmInfo = Object.assign(this.bmInfo, this.points[index]);
      this.bmInfo.show = true;
      // alert(`单击点的坐标为：${e.point.lng}, ${e.point.lat}`)
    },
    mouseout(e) {
      this.bmInfo.show = false;
    },
    // 数据大盘 / 平台信息
    sparePartInfo() {
      let sparePart = echarts.getInstanceByDom(this.$refs["sparePart"]);
      if (sparePart === undefined) {
        this.sparePart = echarts.init(this.$refs["sparePart"]);
        this.$once("hook:beforeDestroy", function () {
          echarts.dispose(this.sparePart);
        });
      }
      this.$http
        .get(`/front/order/lclb/homeData/platformInfo`)
        .then(({ data }) => {
          let dataInfo = data.data;
          this.platformInfo = dataInfo;
          let seriesList = [
            dataInfo.mySparePartsDemandGoodsNum || 0,
            dataInfo.mySparePartsDemandNum || 0,
            dataInfo.myOrderNum || 0,
          ];
          this.sparePartOption.series[0].data = seriesList;
          console.log(this.sparePartOption.series.data);
          this.sparePart.setOption(this.sparePartOption);
        });
    },
    // 领用单记录
    requisitionInfo() {
      let requisition = echarts.getInstanceByDom(this.$refs["requisition"]);
      if (requisition === undefined) {
        this.requisition = echarts.init(this.$refs["requisition"]);
        this.$once("hook:beforeDestroy", function () {
          echarts.dispose(this.requisition);
        });
      }
      this.$http
        .get(`/front/order/lclb/homeData/orderCount`)
        .then(({ data }) => {
          let dataInfo = data.data;
          if (dataInfo.length > 6) {
            dataInfo = dataInfo.reverse().splice(0, 6);
            dataInfo = dataInfo.reverse();
          }
          let xAxisList = [];
          let seriesList = [];
          dataInfo.forEach((item) => {
            xAxisList.push(item.month);
            seriesList.push(item.orderGoodsNum);
          });
          this.requisitionOption.xAxis.data = xAxisList;
          this.requisitionOption.series.data = seriesList;
          this.requisition.setOption(this.requisitionOption);
        });
    },
    // 备件请求统计
    requestInfo() {
      let request = echarts.getInstanceByDom(this.$refs["request"]);
      if (request === undefined) {
        this.request = echarts.init(this.$refs["request"]);
        this.$once("hook:beforeDestroy", function () {
          echarts.dispose(this.request);
        });
      }
      this.$http
        .get(`/front/order/lclb/homeData/sparePartsTop`)
        .then(({ data }) => {
          let dataInfo = data.data;
          let seriesList = [];
          dataInfo.forEach((item) => {
            seriesList.push({
              value: item.goodsNum,
              name: item.province,
            });
          });
          this.requestOption.series.data = seriesList;
          this.request.setOption(this.requestOption);
        });
    },
    // 新公司
    newCompanyInfo() {
      let newCompany = echarts.getInstanceByDom(this.$refs["newCompany"]);
      if (newCompany === undefined) {
        this.newCompany = echarts.init(this.$refs["newCompany"]);
        this.$once("hook:beforeDestroy", function () {
          echarts.dispose(this.newCompany);
        });
        this.$http
          .get(`/front/order/lclb/homeData/mallCompanyIncrease`)
          .then(({ data }) => {
            let dataInfo = data.data;
            let xAxisList = [];
            let seriesList = [];
            dataInfo.forEach((item) => {
              xAxisList.push(item.month);
              seriesList.push(item.registerNum);
            });
            this.newCompanyOption.xAxis[0].data = xAxisList;
            this.newCompanyOption.series[0].data = seriesList;
            this.newCompany.setOption(this.newCompanyOption);
          });
      }
    },
    // 获取地图
    getMapInfo() {
      this.$http
        .get(`/front/order/lclb/homeData/listLclbHomeDataOrderCity`)
        .then(({ data }) => {
          this.points = data.data;
          // dataInfo.forEach(item => {

          // })
          //   {
          //   name: '杭州市',
          //   lng: '120.21666',
          //   lat: '30.254579',
          //   value: 93
          // }
        });
    },
    // 获取商城信息
    getShoppingInfo() {
      this.$http
        .get(`/front/order/lclb/homeData/mallStatistic`)
        .then(({ data }) => {
          this.shoppingInfo = data.data;
        });
    },
    // 打开datav
    openDataV() {
      window.open(
        "https://datav.aliyuncs.com/share/18c9b7b4689156b45883053510658cc1",
        "newwindow",
        "width=" +
          (window.screen.availWidth - 10) +
          ",height=" +
          (window.screen.availHeight - 30) +
          ",top=0,left=0,toolbar=no,menubar=no,scrollbars=no, resizable=no,location=no, status=no,fullscreen=yes"
      );
    },
    handleBtnClick(type) {
      let name = "";
      switch (type) {
        case 1:
          name = "storeSpare";
          break;
        case 2:
          name = "spareRequirementsList";
          break;
        case 3:
          name = "sparePartsLibrary";
          break;
        case 4:
          name = "spareGetList";
          break;
        case 5:
          name = "spareStatementList";
          break;
        case 6:
          name = "sharedSpareParts";
          break;
        case 7:
          name = "shareGoodList";
          break;
      }

      this.$router.push({
        name: name,
      });
    },
    handleCommand (command) {
      // console.log(command)
      this.handleBtnClick(command)
    },
  },
  beforeRouteEnter(to, from, next) {
    if (!localStorage.getItem("defaultCompanyId")) {
      Vue.prototype.$message.warning("请设置默认企业以继续访问联储联备业务！");
      next({
        name: "home",
      });
    } else {
      next();
    }
  },
};
</script>
<style lang="scss" scoped>
/deep/ .anchorBL {
  display: none;
}
.home_page {
  .storeSpare_console {
    padding: 20px;
    background-color: rgba(255, 255, 255, 0.58);
    .title {
      border-left: solid 6px #2092ff;
      font-size: 18px;
      color: #333333;
      padding-left: 10px;
      margin: 20px auto;
      .btn {
        border: 1px solid #2092ff;
        font-size: 14px;
        font-weight: 400;
        text-align: left;
        color: #2092ff;
        line-height: 22px;
        padding: 2px 4px;
        cursor: pointer;
        &:hover {
          background: rgb(251, 247, 247);
        }
        &:active {
          background: #fff;
        }
      }
    }
    .list_box {
      .bg_01 {
        background: linear-gradient(225deg, #4f8fde, #2756ba);
      }
      .bg_02 {
        background: linear-gradient(225deg, #ded84f, #bab027);
      }
      .bg_03 {
        background: linear-gradient(225deg, #4fcdde, #279fba);
      }
      .list_item {
        width: 30%;
        margin: 0;
        margin-bottom: 10px;
        border-radius: 0;
        /deep/ .el-card__body {
          padding: 15px;
        }
        .list_title {
          font-size: 14px;
          margin-bottom: 6px;
          color: #fff;
        }
        .list_num {
          font-size: 26px;
          color: #fff;
          margin-right: 4px;
        }
        .list_num_unit {
          font-size: 14px;
          color: #fff;
        }
        .color {
          color: #999999;
        }
        .color_01 {
          color: #2756ba;
        }
        .color_02 {
          color: #bab027;
        }
        .color_03 {
          color: #279fba;
        }
      }
    }
    .company_list {
      .company_list_item {
        width: 30%;
        height: 300px;
        background: #fff;
        padding: 10px;
      }
    }
    .lclb_map {
      width: 100%;
      background: #fff;
      padding-top: 20px;
      .baidumap {
        width: 100%;
        height: 400px;
      }
    }
    .shop_box {
      // background: #fff;
      padding: 30px 0;
      .shop_left {
        width: 46%;
        padding: 20px;
        background: #fff;
        .shop_left_title {
          text-align: center;
          font-size: 14px;
          color: #666666;
        }
        .shop_left_num {
          text-align: center;
          font-size: 45px;
          color: #73a0fa;
          font-size: 500;
          margin: 0 0 20px 0;
        }
        .shop_left_bottom {
          .shop_left_bottom_item {
            margin: 0;
            margin-bottom: 20px;
            width: 45%;
            border-radius: 0;
            background: #fafbfc;
            border: 1px solid #e8e8e8;
            box-shadow: none;
            /deep/ .el-card__body {
              padding: 10px !important;
            }
            .shop_left_bottom_title {
              font-size: 14px;
              color: rgb(175, 170, 170);
            }
            .shop_left_bottom_num {
              font-size: 30px;
            }
          }
        }
      }
      .shop_box_right {
        background: #fff;
        padding: 20px 0;
        width: 46%;
        height: 364px;
      }
    }
  }
}
.topNav {
  display: flex;
  margin: 16px 0;
  .btn_item {
    font-family: Alibaba PuHuiTi;
    font-size: 16px;
    font-weight: 700;
    line-height: 16px;
    text-align: center;
    color: #333333;
    padding: 8px 16px;
    margin-right: 20px;
    &:hover {
      color: #2a54d1;
      background: #f5f6fa;
    }
  }
}
</style>
